import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import MarketsEqAll from './markets-eq-all';

const MarketsEqAllFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <MarketsEqAll {...props}/>
    </QueryClientProvider>
  );
};

export { MarketsEqAllFullWidget }
